export var defaultToastConfig = {
  position: 'bottom-center',
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  closeButton: false,
  toastClassName: function toastClassName() {
    return 'no-padding';
  },
  bodyClassName: function bodyClassName() {
    return 'no-padding';
  },
  style: {
    boxShadow: 'none',
    padding: 0,
    background: 'none',
    width: 'fit-content',
    zIndex: 99
  }
};